<template>
<v-container class="font-weight-light" fluid fill-height>
    <v-row cols="12">
      <v-col md="10">
          <v-data-table
            dense
            :headers="headers"
            :items="items"
            class="elevation-3"
            multi-sort
            id="genTable"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15]
            }"
          >
          <template v-slot:top>
            <v-row no-gutters class="ml-3" justify="start">
              <v-col
                cols="4"
                sm="3"
                md="2"
                lg="1"
                class="pl-2 mr-2"
              >
                <v-btn block
                  small
                  color="primary"
                  class="white--text font-weight-light mt-4" 
                  @click="openAddDialog">{{getTranslation('Schedule service')}}</v-btn>
                  
              </v-col>
              <v-col
                cols="3"
              >
              <v-checkbox v-model="showInactive" class="mx-2 mt-3" :label="getTranslation('Show inactive')"></v-checkbox>
               </v-col>
               <v-col cols="3" class="hidden-md-and-up ml-4">
                <v-checkbox v-model="filterDrawer" label="Filters" class="mx-2 mt-3"></v-checkbox>

                <v-navigation-drawer v-model="filterDrawer" app clipped width="425" height="auto" right>
                  <v-toolbar flat dark class="primary" dense>
                    <v-row justify="space-between" align="center">
                      <v-toolbar-title class="ml-4">Filters</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.stop="filterDrawer = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-row>
                  </v-toolbar>
                  <!-- // Mobile filter -->
                  <v-list dense>
                    <v-col cols="12">
                      <v-card class="mr-5">
        <v-col>
        <v-autocomplete
            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="selectedVehicleGroups"
            :items="select.vehicleGroups"
            :label="getTranslation('Vehicle groups')"
            multiple
          ></v-autocomplete>
          <v-autocomplete

            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="searchObject.vehicleIds"
            :items="select.vehicles"
            :label="getTranslation('Vehicle types')"
            multiple
          ></v-autocomplete>
          <v-autocomplete
            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="searchObject.serviceTypes"
            :items="select.servicetypes"
            :label="getTranslation('Service type')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-row justify="center">
        <v-col sm="12" md="5" class="py-0">
          <v-menu
            ref="menu"
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y

          >
            <template v-slot:activator="{ on }">
              <v-text-field dense :label="getTranslation('Start date')" v-model="searchObject.startDate" v-on="on" hide-details="auto"></v-text-field>
            </template>
            <v-date-picker
            
              v-model="searchObject.startDate"
              no-title
              @input="startDateMenu = false"
              @change="setBeginDate"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col sm="12" md="5" class="py-0">
          <v-menu
            ref="menu"
            v-model="endDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field :label="getTranslation('End date')" dense v-model="searchObject.endDate" v-on="on" hide-details="auto"></v-text-field>
            </template>
            <v-date-picker
              v-model="searchObject.endDate"
              no-title
              @input="endDateMenu = false"
              @change="setEndDate"
              :min="searchObject.startDate"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
        <v-col>
              <v-btn block  small @click="search"  color="primary">
                  <v-icon color="white" class="font-weight-light">search</v-icon>
          </v-btn>
        </v-col>
      </v-card> 
                    </v-col>
                  </v-list>
                </v-navigation-drawer>
              </v-col>
            </v-row>
          </template>
          <template v-slot:header.crud="{ header }">
            <BaseTooltip>{{$t('tooltips.Edit or delete item')}}</BaseTooltip>
          </template>
          <template v-slot:item.isActive="{ item }">
              <v-icon v-if="item.isActive == true" color="green darken-2">done</v-icon>
              <v-icon v-else color="red">highlight_off</v-icon>
          </template>
          <template v-slot:item.crud="{ item }">
            <div v-if="item.isActive == true">
              <v-btn
                icon
                small
                @click="openUpdateDialog(item.id)"
                class="pr-3"
              >
                <v-icon color="primary">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                @click="openDeleteDialog(item.id)"
                class="pr-3"
              >
                <v-icon color="secondary">delete</v-icon>
              </v-btn>
            </div>
          </template>
          </v-data-table>
      </v-col>
      <v-col md="2" v-if="bPoint.mdAndUp">
      <v-card class="mr-5">
        <v-col>
        <v-autocomplete
            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="selectedVehicleGroups"
            :items="select.vehicleGroups"
            :label="getTranslation('Vehicle groups')"
            multiple
          ></v-autocomplete>
          <v-autocomplete

            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="searchObject.vehicleIds"
            :items="select.vehicles"
            :label="getTranslation('Vehicle types')"
            multiple
          ></v-autocomplete>
          <v-autocomplete
            class="font-weight-light" 
                color="primary"
                outlined
                dense
                hide-details="auto"
            v-model="searchObject.serviceTypes"
            :items="select.servicetypes"
            :label="getTranslation('Service type')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-row justify="center">
        <v-col sm="12" md="5" class="py-0">
          <v-menu
            ref="menu"
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y

          >
            <template v-slot:activator="{ on }">
              <v-text-field dense :label="getTranslation('Start date')" v-model="searchObject.startDate" v-on="on" hide-details="auto"></v-text-field>
            </template>
            <v-date-picker
            
              v-model="searchObject.startDate"
              no-title
              @input="startDateMenu = false"
              @change="setBeginDate"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col sm="12" md="5" class="py-0">
          <v-menu
            ref="menu"
            v-model="endDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field :label="getTranslation('End date')" dense v-model="searchObject.endDate" v-on="on" hide-details="auto"></v-text-field>
            </template>
            <v-date-picker
              v-model="searchObject.endDate"
              no-title
              @input="endDateMenu = false"
              @change="setEndDate"
              :min="searchObject.startDate"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
        <v-col>
              <v-btn block  small @click="search"  color="primary">
                  <v-icon color="white" class="font-weight-light">search</v-icon>
          </v-btn>
        </v-col>
      </v-card> 
      </v-col>
      
    </v-row>
    <template>
       <v-dialog
        v-model="dialog"
        max-width="500px"
        :retain-focus="false"
        persistent
        :fullscreen="$vuetify.breakpoint.mobile"
      >
        <ServiceScheduleDialog
          @updateDialog = onExit
          :identifier = identifier
          :isUpdate = isUpdate
          :title = title
        >
        </ServiceScheduleDialog>
      </v-dialog>
      <v-dialog v-model="dialogDelete" persistent max-width="400px" :retain-focus="false">
        <base-dialog-confirmation @close="onExit" @submit="onDeleteEvent">
          <h4>{{this.getTranslation('Delete question')}}</h4>
        </base-dialog-confirmation>
      </v-dialog>
      </template>
  </v-container>
</template>
<script>
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import ServiceScheduleDialog from '@/views/serviceBook/ServiceScheduleDialog'
import BaseDialogConfirmation from '@/components/BaseDialogConfirmation'
import { integer } from 'vee-validate/dist/rules'
import VDateTextBox from '@/components/custom/VDateTextBox'

export default {
  data() {
    return {
      filterDrawer: false,
      title: '',
      startDateMenu: false,
      endDateMenu: false,
      showInactive: false,
      selectedVehicleGroups: [],
      queryString: '',
      endPoint: 'serviceSchedules',
      vehicles: [],
      select: {
        vehicleGroups: [],
        vehicles: [],
        servicetypes: []
      },
      searchObject: {
        vehicleIds: [],
        startDate: null,
        endDate: null
      },
      deleteIdentifier: integer,
      identifier: integer,
      dialog: false,
      dialogDelete: false,
      isUpdate: false,
      headers: [
        {
          text: this.getTranslation('Service type'),
          value: 'serviceTypeName'
        },
        {
          text: this.getTranslation('Registration Mark'),
          value: 'vehicleLabel'
        },
        {
          text: this.getTranslation('Frequency'),
          value: 'frequencyName'
        },
        {
          text: this.getTranslation('Planned'),
          value: 'occursAt'
        },
        {
          text: this.getTranslation('Active'),
          value: 'isActive'
        },
        {
          text: 'Actions',
          value: 'crud',
          sortable: false
        }
      ],
      items: []
    }
  },
  components: {
    ServiceScheduleDialog,
    BaseDialogConfirmation,
    VDateTextBox,
    BaseTooltip: () => import('@/components/BaseTooltip')
  },
  mounted() {
    this.getActiveItems()
    httpClient.get('lookup/vehiclegroups').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.id
        }
        this.select.vehicleGroups.push(obj)
      }
    })
    httpClient.get('vehicles').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.id,
          vehicleGroupIds: data.vehicleGroupIds
        }
        this.select.vehicles.push(obj)
        this.vehicles.push(obj)
      }
    })
    this.getServiceTypeSelect()
  },
  methods: {
    getTranslation(value) {
      return translate(value, 'pages.serviceSchedules')
    },
    setBeginDate(value) {
      this.searchObject.startDate = value
    },
    adaptDates(items) {
      for (let item of items) {
        if (item.plannedDate != null) {
          item.plannedDateParsed = this.$i18n.d(
            new Date(item.plannedDate.replace('T', ' ')),
            'long',
            this.$i18n.locale
          )
          item.plannedDate = item.plannedDate
        }
      }
      return items
    },
    setEndDate(value) {
      this.searchObject.endDate = value
    },
    onExit() {
      this.isUpdate = false
      this.dialog = false
      this.dialogDelete = false
      this.identifier = null
      this.getByActivity()
    },
    openUpdateDialog(value) {
      this.identifier = value
      this.title = this.getTranslation('Update title')
      this.isUpdate = true
      this.dialog = true
    },
    openAddDialog() {
      this.identifier = null
      this.title = this.getTranslation('Add title')
      this.isUpdate = false
      this.dialog = true
    },
    openDeleteDialog(value) {
      this.dialogDelete = true
      this.deleteIdentifier = value
    },
    onDeleteEvent() {
      store.dispatch('genTables/setEndpoint', 'serviceSchedules')
      store.dispatch('genTables/deleteTableItem', this.deleteIdentifier)
      this.getByActivity()
    },
    buildQuery() {
      let firstAppend = true
      if (this.searchObject.vehicleIds.length > 0) {
        for (let id of this.searchObject.vehicleIds) {
          firstAppend = this.appendQuestionMark(firstAppend)
          this.queryString += 'VehicleIds=' + id + '&'
        }
      }
      if (this.searchObject.startDate != null) {
        firstAppend = this.appendQuestionMark(firstAppend)
        this.queryString += 'startDate=' + this.searchObject.startDate + '&'
      }
      if (this.searchObject.endDate != null) {
        firstAppend = this.appendQuestionMark(firstAppend)
        this.queryString += 'endDate=' + this.searchObject.endDate + '&'
      }
      if (this.searchObject.serviceTypes != null) {
        for (let id of this.searchObject.serviceTypes) {
          firstAppend = this.appendQuestionMark(firstAppend)
          this.queryString += 'ServiceTypes=' + id + '&'
        }
      }
    },
    getItems() {
      httpClient.get(this.fullPath).then(response => {
        let data = this.adaptDates(response.data)
        this.items = data
      })
    },
    search() {
      this.resetSearchQuery()
      this.buildQuery()
      this.getByActivity()
    },
    appendQuestionMark(value) {
      if (value == true) {
        this.queryString += '?'
        return false
      }
    },
    getByActivity() {
      if (this.showInactive == true) {
        this.getItems()
      } else {
        this.getActiveItems()
      }
    },
    resetSearchQuery() {
      this.queryString = ''
    },
    getServiceTypeSelect() {
      httpClient.get('servicetypes').then(response => {
        for (const data of response.data) {
          let obj = {
            text: data.name,
            value: data.id
          }
          this.select.servicetypes.push(obj)
        }
      })
    },
    getActiveItems() {
      let tempItems = []
      httpClient.get(this.fullPath).then(response => {
        let data = this.adaptDates(response.data)
        for (let item of data) {
          if (item.isActive == true) {
            tempItems.push(item)
          }
        }
      })
      this.items = tempItems
    },
    adaptTextForDropDown(text) {
      let adaptedText = ''
      for (let letter in text) {
        if (letter == 0) {
          adaptedText += text[letter].toUpperCase()
        } else if (text[letter] == text[letter].toUpperCase()) {
          adaptedText += text[letter].toLowerCase()
        } else {
          adaptedText += text[letter]
        }
      }
      return adaptedText
    }
  },
  computed: {
    fullPath() {
      return this.endPoint + this.queryString
    },
    bPoint() {
      return this.$vuetify.breakpoint
    }
  },
  watch: {
    selectedVehicleGroups: {
      handler() {
        if (this.selectedVehicleGroups.length == 0) {
          this.select.vehicles = this.vehicles
        } else {
          this.select.vehicles = []
          for (let vehicle of this.vehicles) {
            for (let groupId of vehicle.vehicleGroupIds) {
              for (let group of this.selectedVehicleGroups) {
                if (group == groupId) {
                  this.select.vehicles.push(vehicle)
                }
              }
            }
          }
        }
      }
    },
    showInactive: {
      handler() {
        this.getByActivity()
      }
    },
    items: {
      handler() {
        this.items.forEach(element => {
          element['serviceTypeName'] = this.getTranslation(
            this.adaptTextForDropDown(element['serviceTypeName'])
          )
          element['frequencyName'] = this.getTranslation(
            this.adaptTextForDropDown(element['frequencyName'])
          )
        })
      }
    }
  }
}
</script>
<style scoped>
#genTable >>> thead > tr > th {
  background-color: #009ad5;
  color: white;
}
</style>
